import React, { Component } from "react"
import { connect } from "react-redux"
import BraintreeModal from "./BraintreeModal"
import MiniLoader from "./MiniLoader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-light-svg-icons"
import CustomNotification from "./CustomNotification"
import { NOTIFICATION_TYPE } from "../../constants/notification"
import { withTranslation } from "react-i18next"
import { DRIVER, MANAGER } from "../../constants/roles"
import { Button } from "semantic-ui-react"

class BraintreeAddPaymentComponent extends Component {
  constructor(props) {
    super(props)
    this.braintreeModal = React.createRef()
  }

  state = {
    modalOpen: false
  }

  openModal = async () => {
    await this.setState({ modalOpen: true })
    this.braintreeModal.current.setupBraintree()
  }

  closeModal = () => {
    this.setState({ modalOpen: false })
  }

  addPaymentMethod = async (nonce, formData, ach = false, is_default = false) => {
    const { t, dispatch } = this.props
    await dispatch({
      type: "PAYMENT_METHOD_CREATE_SAGA",
      payload: { nonce: nonce, formData: formData, t: t, ach: ach, is_default: is_default },
      callback: this.afterRequest.bind(this)
    })
    this.closeModal()
  }

  getNonce = async (nonce, formData, ach = false) => {
    const { fetchNonce } = this.props
    fetchNonce(nonce, formData, ach)
    this.closeModal()
  }

  afterRequest(status, data) {
    if (status === NOTIFICATION_TYPE.SUCCESS) {
      this.onRequestSuccess(data)
    } else {
      this.onRequestFailure(data)
    }
  }

  onRequestFailure(data) {
    const { type, title, message } = data
    const { t } = this.props
    return CustomNotification(type, title, message, t)
  }

  onRequestSuccess(data) {
    const { type, title, message } = data
    const { t } = this.props
    return CustomNotification(type, title, message, t)
  }

  render() {
    const {
      clientToken,
      isLoading,
      users,
      affiliation,
      t,
      language,
      currentFleet,
      editingId,
      fromFleetNew
    } = this.props

    return (
      <React.Fragment>
        <BraintreeModal
          ref={this.braintreeModal}
          clientToken={clientToken}
          modalOpen={this.state.modalOpen}
          closeModal={this.closeModal}
          saveCallback={fromFleetNew ? this.getNonce : this.addPaymentMethod}
          users={users.filter(function (item) {
            if (
              (item.roles.length == 1 &&
                !item.roles.includes(DRIVER) &&
                !item.roles.includes(MANAGER)) ||
              (item.roles.length == 2 &&
                JSON.stringify(item.roles.sort()) !== JSON.stringify([DRIVER, MANAGER])) ||
              item.roles.length > 2
            )
              return item
          })}
          t={t}
          language={language}
          fleet={currentFleet}
          affiliation={affiliation}
          fromFleetNew={fromFleetNew}
        />
        {!clientToken ? (
          <div style={{ float: "right" }}>
            <MiniLoader inverted={false} />
            {t("pleaseWaitLabel")}..
          </div>
        ) : (
          <Button
            disabled={isLoading || editingId}
            onClick={this.openModal}
            floated="right"
            size="tiny"
            style={{ width: fromFleetNew ? "100%" : undefined }}
          >
            <FontAwesomeIcon icon={faPlus} className="button-icon-color" />
            {t("addNewPaymentLabel")}
          </Button>
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps)(withTranslation("settings")(BraintreeAddPaymentComponent))
